import { gql } from '@apollo/client/core'

/** Minimal club + nested courses for home Featured Venues (see FeaturedClubs.vue). */
export const FEATURED_CLUBS_CLUB_FRAGMENT = gql`
  fragment FeaturedClubsClub on Club {
    id
    clubName
    slug
    city
    logo
    gallery
    averageRating
    courses {
      ... on ListCoursesOutput {
        courses {
          courseName
          numHoles
          par
          priceRange
          gallery
          slug
        }
      }
    }
  }
`
